export default __webpack_public_path__ + "static/mobVector-709a0f995187d7dbdf37674ca90c997a.svg";